export default __webpack_public_path__ + "static/media/exit.c5650d4e.svg";